// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__Zsm-6","header":"PatientBlock_header__8C3pf","label":"PatientBlock_label__WsZZ6","option":"PatientBlock_option__26thK"};